/**
 * @fileoverview 授权配置
 * @author zhenn
 */

var Url = require('c-url');

module.exports = {

    // webapi域名配置
    originMap: {
        dev : 'http://up-service.xingyunzhi.cn',
        stage: 'https://sg-service.pengpengla.com',
        pro : 'https://service.upliveapps.com'
    },

    getPrefix: function() {
        let prefix = this.originMap[this.env()];

        return prefix;
    },

    getTwitterRequestTokenPath: function() {
        let prefix = this.getPrefix();
        return prefix + '/webauth/twitter/requesttoken';
    },

    // 通过code获取userToken的webapi路径
    getUsertokenPath : function () {
        let prefix = this.getPrefix();
        var target = prefix + '/webauth/auth';
        return target;
    },

    // 获取环境
    env: function () {
        return Url.query('env') || 'pro';
    },

    // 碰碰在sns平台中信息
    // key值为sourceid
    upInfoInPlatform : {

        //微信平台
        'wechat' : {
            appid : 'wx78a12cd5f3b2a993',
            appid_stage : 'wx78a12cd5f3b2a993'
        },

        'fb': {
            appid: '1698316857098420'
        },
        'weibo': {
            appid: '3739970591'
        }

    }


};





// WEBPACK FOOTER //
// ./js/config.js